<template>
  <div class="home-CommonlyUsed">
    <div v-for="(item, index) in list" :key="index" class="item" @click="selectClick(item)">
      <div class="close-panel">
        <a-icon type="close" @click.stop="removeClick(item, index)" />
      </div>
      <img :src="item.logoUrl" />
      <p>{{item.menuName}}</p>
    </div>
    <div class="item-add" @click="addClick">
      <a-icon type="plus" style="font-size: 30px; margin-top: 20px; margin-bottom: 10px;" />
      <p>添加</p>
    </div>
    <commonly-used-select ref="CommonlyUsedSelect" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { microRouterPush } from '@/utils/microTools'
import { getCommonFunctions, deleteCommonFunctions } from '@/api/home'
export default {
  components: {
    CommonlyUsedSelect: () => import('./CommonlyUsedSelect.vue')
  },
  inject: ['toast', 'confirm', 'popup'],
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapGetters(['systemList'])
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      const res = await getCommonFunctions()
      const { data } = await this.toast(res)
      this.list = !Array.isArray(data) ? [] : data.map(({ id, menuId, menuCode, menuName, logoUrl, uri, subsystemCode }) => {
        return { id, menuId, menuCode, menuName, logoUrl, uri, subsystemCode }
      })
    },
    selectClick({ uri, subsystemCode }) {
      microRouterPush(subsystemCode, uri)
    },
    async removeClick({ id }, index) {
      await this.confirm('确认删除？删除后无法在首页快速跳转')
      this.list.splice(index, 1)
      const res = await deleteCommonFunctions(id)
      await this.toast(res)
      this.initData()
    },
    addClick() {
      this.popup('CommonlyUsedSelect', this.list).then(() => {
        this.initData()
      }).catch(() => {
        console.log('取消')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home-CommonlyUsed{
  .item{
    width: 120px;
    height: 92px;
    background: #FAFAFA;
    text-align: center;
    border-radius: 5px;
    border: 1px solid transparent;
    display: inline-block;
    margin-right: 12px;
    margin-bottom: 12px;
    img{
      height: 32px;
    }
    p{
      font-size: 12px;
      color: rgba(51,51,51,0.85);
      padding-top: 8px;
    }
    .close-panel{
      height: 20px;
      text-align: right;
      .anticon-close{
        color: #9fa2a9;
        margin-right: 3px;
        cursor: pointer;
        display: none;
      }
    }
    &:hover{
      background: #F3FBFA;
      border-color: #00A497;
      .anticon-close{
        display: inline-block;
      }
    }
  }
  .item-add{
    width: 120px;
    background: #FAFAFA;
    color: #00A497;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid transparent;
    display: inline-block;
    padding-bottom: 13px;
    &:hover{
      border-color: #00A497;
    }
  }
}
</style>
